<template>
    <div class="main-container">
        <logoComponent />
        <AdEditComponent
            dashboard
            fetch
            @updated="onUpdate"
        />
    </div>
</template>

<script>
import LogoComponent from '@/components/LogoComponent';
import AdEditComponent from '@/components/AdEditComponent';
import store from '@/services/business/store';

export default {
    name: 'DashboardPage',
    metaInfo: {
		title: 'Dashboard - LensAdvisors Business',
		meta: [
			{ vmid: 'description', name: 'description', content: 'Manage your ads on LensAdvisors' }
		]
	},
    components: {
        LogoComponent,
        AdEditComponent
    },
    data: () => {
        return {
            sharedState: store.state
        }
    },
    methods: {
        onUpdate() {
            store.updateAd(this.sharedState.adInfo);
        }
    }
};
</script>

<style lang="scss" scoped>
    .main-container {
        height: 100vh;
        width: 100vw;


    }
</style>